export const SAVE_SETTING_UPSELL_POPUP_CAMPAIGN = 'SAVE_SETTING_UPSELL_POPUP_CAMPAIGN';
export const SAVE_SETTING_UPSELL_POPUP_CAMPAIGN_RESULT = 'SAVE_SETTING_UPSELL_POPUP_CAMPAIGN_RESULT';

export const GET_LIST_UPSELL_POPUP = 'GET_LIST_UPSELL_POPUP';
export const GET_LIST_UPSELL_POPUP_RESULT = 'GET_LIST_UPSELL_POPUP_RESULT';

export const GET_DETAIL_CAMPAIGN_UPSELL_POPUP = 'GET_DETAIL_CAMPAIGN_UPSELL_POPUP';
export const GET_DETAIL_CAMPAIGN_UPSELL_POPUP_RESULT = 'GET_DETAIL_CAMPAIGN_UPSELL_POPUP_RESULT';

export const CHANGE_UPSELL_POPUP_SETTING_FIELD = 'CHANGE_UPSELL_POPUP_SETTING_FIELD';
export const CHANGE_UPSELL_POPUP_PRODUCT_DETAIL_FIELD = 'CHANGE_UPSELL_POPUP_PRODUCT_DETAIL_FIELD';
export const CHANGE_UPSELL_POPUP_FIELD = 'CHANGE_UPSELL_POPUP_FIELD';

export const CHANGE_TARGET_PRODUCT_UPSELL_POPUP = 'CHANGE_TARGET_PRODUCT_UPSELL_POPUP';
export const CHANGE_TARGET_PRODUCT_UPSELL_POPUP_RESULT = 'CHANGE_TARGET_PRODUCT_UPSELL_POPUP_RESULT';

export const CHANGE_LIST_TARGET_POPUP_COLLECTION = 'CHANGE_LIST_TARGET_POPUP_COLLECTION';
export const CHANGE_LIST_TARGET_POPUP_COLLECTION_RESULT = 'CHANGE_LIST_TARGET_POPUP_COLLECTION_RESULT';

export const CHANGE_LIST_RECOMMEND_POPUP_PRODUCT = 'CHANGE_LIST_RECOMMEND_POPUP_PRODUCT';
export const CHANGE_LIST_RECOMMEND_POPUP_PRODUCT_RESULT = 'CHANGE_LIST_RECOMMEND_POPUP_PRODUCT_RESULT';

export const CHANGE_LIST_RECOMMEND_POPUP_COLLECTION = 'CHANGE_LIST_RECOMMEND_POPUP_COLLECTION';
export const CHANGE_LIST_RECOMMEND_POPUP_COLLECTION_RESULT = 'CHANGE_LIST_RECOMMEND_POPUP_COLLECTION_RESULT';

export const CHANGE_DC_UPSELL_POPUP_COMMON = 'CHANGE_DC_UPSELL_POPUP_COMMON';
export const CHANGE_DC_TARGET_POPUP_COMMON = 'CHANGE_DC_TARGET_POPUP_COMMON';

export const CHANGE_STATUS_UPSELL_POPUP = 'CHANGE_STATUS_UPSELL_POPUP';
export const CHANGE_STATUS_UPSELL_POPUP_RESULT = 'CHANGE_STATUS_UPSELL_POPUP_RESULT';
export const DELETE_CAMPAIGN_UPSELL_POPUP = 'DELETE_CAMPAIGN_UPSELL_POPUP';
export const DELETE_CAMPAIGN_UPSELL_POPUP_RESULT = 'DELETE_CAMPAIGN_UPSELL_POPUP_RESULT';
export const GET_PRODUCTS_IN_COLLECTION = 'GET_PRODUCTS_IN_COLLECTION';

export const REMOVE_TARGET_PRODUCT_UPSELL_POPUP = 'REMOVE_TARGET_PRODUCT_UPSELL_POPUP';
export const REMOVE_TARGET_COLLECTION_UPSELL_POPUP = 'REMOVE_TARGET_COLLECTION_UPSELL_POPUP';
export const REMOVE_RECOMMEND_PRODUCT_UPSELL_POPUP = 'REMOVE_RECOMMEND_PRODUCT_UPSELL_POPUP';
export const REMOVE_RECOMMEND_COLLECTION_UPSELL_POPUP = 'REMOVE_RECOMMEND_COLLECTION_UPSELL_POPUP';
